export const adap_item_producto_carrito = ({entidad, variante}) =>{

    let obj = {
        ...entidad,
        id: (entidad.nombre + '_' + variante.nombre).replaceAll(' ', '_'),
        variante: variante.nombre,
        valor: variante.valor,
        peso: variante.peso,
    }
    delete obj.variantes
    delete obj.informaciones
    delete obj.estado

    return obj

}